import {useEffect, useRef, useState} from "react";

export default function VideoModal({isOpen, src, poster, onClose}) {
    const videoRef = useRef(null);
    const [playbackError, setPlaybackError] = useState("");

    useEffect(() => {
        const video = videoRef.current;

        if (!isOpen) {
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
            return undefined;
        }

        setPlaybackError("");
        const handleKeyDown = function (event) {
            if (event.key === "Escape") onClose();
        };

        window.addEventListener("keydown", handleKeyDown);
        if (video) {
            video.load();
            video.play().catch(function () {
                setPlaybackError("视频未能自动播放，请点击播放按钮重试。");
            });
        }

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            if (video) video.pause();
        };
    }, [isOpen, onClose, src]);

    return (
        <div
            className={isOpen ? "home-video-mask open" : "home-video-mask"}
            aria-hidden={isOpen ? "false" : "true"}
            onClick={(event) => {
                if (event.target === event.currentTarget) onClose();
            }}
        >
            <section className="home-video-modal" role="dialog" aria-modal="true" aria-labelledby="homeVideoTitle">
              
                <button className="home-video-close" type="button" aria-label="关闭视频" onClick={onClose}>×</button>
                <div className="home-video-frame">
                    <video
                        ref={videoRef}
                        controls
                        autoPlay
                        muted
                        playsInline
                        preload="metadata"
                        poster={poster}
                        onPlaying={() => setPlaybackError("")}
                        onError={() => setPlaybackError("视频加载失败，请检查视频地址后重试。")}
                    >
                        <source src={src} type="video/mp4"/>
                        当前浏览器不支持视频播放。
                    </video>
                    {playbackError && <p className="home-video-error" role="status">{playbackError}</p>}
                </div>               
            </section>
        </div>
    );
}
